import { gql } from '@/__generated__/storefront';

export const productGroupIdByHandleQuery = gql(`
  query ProductGroupIdByHandle($handle: String!) {
    product(handle: $handle) {
      entityId: metafield(namespace: "hobbii", key: "product_group_id") {
        value
      }
    }
  }
`);

export const predictiveSearchQuery = gql(`
  query suggestions($query: String!) {
    predictiveSearch(query: $query, types: [PRODUCT]) {
      products {
        id
        title
        onlineStoreUrl
        featuredImage {
          url
          altText
          height
          width
        }
        sanityEntityId: metafield(namespace: "hobbii", key: "entity_id") {
          value
        }
        hobbiiSku: metafield(namespace: "hobbii", key: "sku") {
          value
        }
        openCartId: metafield(namespace: "hobbii", key: "opencart_id") {
          value
        }
      }
    }
  }
`);
